module.exports = __webpack_public_path__ + "static/img/ba3.de9c89e7.png";